<template>
  <v-container fluid grid-list-md ma-0 pa-0>
  <v-layout class="pa-md-4" row wrap>
      <v-flex>
        <v-select
          v-model="serviceFilter"
          :items="services"
          label="Filter by services"
          color="primary"
          solo
          hint="Services"
          persistent-hint
        ></v-select>
      </v-flex>
      <v-flex>
        <v-btn large color="primary" @click="getfilteredData">
          Search
        </v-btn>
      </v-flex>
    <v-row justify="center">
      <v-snackbar v-model="snackbar" color="accent" :timeout="timeout" bottom>
        Please use the select boxes at the top to filter services
        <v-btn dark text @click="snackbar = false">
          Close
        </v-btn>
      </v-snackbar>
    </v-row>
     <serv-render :index="pageIndex" :cards="myJson" :key="pageId"></serv-render>
    </v-layout>
  </v-container>
</template>

<script>
import serviceData from "@/services";
import ServRender from "@/components/ServRender";
export default {
  name: "ExploreServices",
  components: {
    "serv-render": ServRender
  },
  data: () => ({
    panel: 0,
    noArrows: false,
    snackbar: true,
    timeout: 25000,
    slides: [
      "1.Click on the service you like",
      "2.If its hosting,your service will be online in 3 hrs",
      "3.We will contact you and ask for the details",
      "4.Within 24 hours your service will be online"
    ],
    pageIndex: 0,
    pageId: 0,
    serviceFilter: [],
    myJson: [],
    initJson: serviceData,
    services: ["All", "Custom Application Development", "Hosting"]
  }),
  methods: {
    getfilteredData() {
      this.pageId++;
      this.pageIndex = 0;
      this.myJson = [];
      if (this.serviceFilter == "" || this.serviceFilter == "All") {
        this.myJson = this.initJson;
      } else {
        var filter1 = this.serviceFilter;
        this.myJson = this.initJson.filter(function(itm) {
          return itm.serviceType == filter1;
        });
      }
    }
  },
  created() {
    this.getfilteredData();
  }
};
</script>
